var StudentDisplay = require("components/users/students/StudentDisplay");
require("data/no_activity_block");

var NoActivityBlock = function(props) {
	var students = _.map(props.userIDs, (userID) => {
		return (
			<div key={ userID }>
				<StudentDisplay studentID={ userID } showAvatar avatarMaxWidth={ 40 } />
			</div>
		)
	})
	var header = ''
	if (!props.hideHeader) {
		header = <p className="noActivityHeader">No {props.contentType}</p>
	}
	return (
		<div className="hideOnPrint noActivityBlock">
			{ header }
			{ students }
		</div>
	);

};

NoActivityBlock.propTypes = StrictPropTypes({
	studentID: PropTypes.number,
	contentType: PropTypes.string,
	userIDs: PropTypes.array
});

module.exports = NoActivityBlock;



// WEBPACK FOOTER //
// ./modules/components/data/subjects/shared/NoActivityBlock.js